export function hasAiCoachingAccess(user: {
  aiCoachingEnabled?: boolean;
  coachAccessUnlocked?: boolean;
} | null | undefined): boolean {
  return Boolean(user?.aiCoachingEnabled || user?.coachAccessUnlocked);
}

export function hasAdFreeExperience(user: {
  adFreeEnabled?: boolean;
  aiCoachingEnabled?: boolean;
  coachAccessUnlocked?: boolean;
} | null | undefined): boolean {
  return Boolean(user?.adFreeEnabled || hasAiCoachingAccess(user));
}
